module.exports = __webpack_public_path__ + "img/kl_thumb.4d2933c0.gif";